module.exports = __webpack_public_path__ + "static/img/systemLoginBG2.0d43d9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/systemLoginBG2.jpg
// module id = 1260
// module chunks = 160